import moment from 'moment-timezone';

export const markReadingAsOutlier = ({
  tagId,
  dataPoint,
  machineChartsActions,
  refreshChartAfterOutlier,
  onClose
}) => {
  const timestamp = moment.utc(dataPoint.x).format('YYYY-MM-DD HH:mm:ss');
  return machineChartsActions.postOutlierReading(tagId, timestamp).then(() => {
    onClose();
    refreshChartAfterOutlier();
  }).catch((error) => {
    console.error('Failed to mark reading as outlier:', error);
  });
};

export const deleteOutlierReading = ({
  tagId,
  dataPoint,
  machineChartsActions,
  refreshChartAfterOutlier,
  onClose
}) => {
  const timestamp = moment.utc(dataPoint.x).format('YYYY-MM-DD HH:mm:ss');
  return machineChartsActions.deleteOutlierReading(tagId, timestamp).then(() => {
    onClose();
    refreshChartAfterOutlier();
  }).catch((error) => {
    console.error('Failed to delete outlier reading:', error);
  });
};

export const setAsFDP = ({
  tagId,
  dataPoint,
  componentId,
  machineId,
  siteId,
  rulActions,
  onClose
}) => {
  const timestamp = moment.utc(dataPoint.x).format('YYYY-MM-DD HH:mm:ss');
  const args = {
    tag_settings: {}
  };
  args.tag_settings[tagId] = {
    fdp: timestamp
  };

  return rulActions.updateRULSettings(componentId, args, machineId, siteId).then(() => {
    onClose();
  }).catch((error) => {
    console.error('Failed to set FDP:', error);
  });
};

export const deleteFDP = ({
  tagId,
  componentId,
  machineId,
  siteId,
  rulActions,
  onClose
}) => {
  const args = {
    tag_settings: {}
  };
  args.tag_settings[tagId] = {
    fdp: null
  };

  return rulActions.updateRULSettings(componentId, args, machineId, siteId).then(() => {
    onClose();
  }).catch((error) => {
    console.error('Failed to delete FDP:', error);
  });
};

export const setAsStartTime = ({
  dataPoint,
  componentId,
  machineId,
  siteId,
  rulActions,
  onClose
}) => {
  const timestamp = moment.utc(dataPoint.x).format('YYYY-MM-DD HH:mm:ss');
  const args = {
    start_time: timestamp
  };
  return rulActions.updateRULSettings(componentId, args, machineId, siteId).then(() => {
    onClose();
  }).catch((error) => {
    console.error('Failed to set start time:', error);
  });
};

export const deleteStartTime = ({
  componentId,
  machineId,
  siteId,
  rulActions,
  onClose
}) => {
  const args = {
    start_time: null
  };
  return rulActions.updateRULSettings(componentId, args, machineId, siteId).then(() => {
    onClose();
  }).catch((error) => {
    console.error('Failed to delete start time:', error);
  });
};
